<template>
  <div>
    <input v-if="searchable" v-model="search" type="text" class="tw-w-full tw-p-4 tw-bg-light-4 tw-rounded" :placeholder="placeholder">
    <div class="tw-divide-y tw-divide-light-3 tw-overflow-auto tw-my-5">
      <slot v-for="option in filteredOptions" name="option" v-bind:option="option" />
      <div v-if="options.length === 0" class="tw-p-4 tw-text-center tw-font-bold">No matches found</div>
    </div>
  </div>
</template>
<script>
  export default {
    props : {
      placeholder : {},
      options  : {},
      filter : {},
      searchable : {
        default : true,
      },
    },
    data : v => ({
      search : '',
    }),
    computed: {
      filteredOptions() {
        return this.options.filter(option => this.filter(option,this.search))
      }
    },
  }
</script>
